
export const hoursFunctions = {

	compileHours(restaurants){
  		if(restaurants){
    		var openList = restaurants.map(this.hoursLister);
    	return(openList)
  		}
	},

	hoursLister(restaurant){
		let currentDate = new Date();
		let convertedDate = [(currentDate.getDay()*24)+currentDate.getHours(),currentDate.getMinutes()]
		let allHours = []
		for(let day = 0; day < restaurant['hours'].length; day++){	
			let separated = restaurant['hours'][day].split(" ")
			
			let amHours = separated[0].split(":");
			let pmHours = separated[3].split(":");
	
			let conAmHours = hoursFunctions.convert24Hour(amHours[0],separated[1]);
			let conPmHours = hoursFunctions.convert24Hour(pmHours[0],separated[4]);
	
			conAmHours = parseFloat(conAmHours);
			conPmHours = parseFloat(conPmHours);
			
			//take care of closing times in the AM (2:00 AM etc.)
			//this assumes nothing closes later than 4 AM the next day
			if (separated[4]==='AM' && parseInt(pmHours[0]) < 5){
				conPmHours = parseFloat(conPmHours, 10)+24;
			}
			if(separated[4]==='AM' && parseInt(pmHours[0]) === 12){
				conPmHours = 24	
			}
	
			//this takes care of split hours
			let realDay = restaurant['splitHours']?Math.floor(day/2):day
			//convert to hour of the week
			conAmHours = ((realDay * 24) + conAmHours)%(24*7)
			conPmHours = ((realDay * 24) + conPmHours)%(24*7)
			
			//push the results to an array where each entry is another array
			// [hour of the week, minutes, open/close, string of time for display]
			if(restaurant['hours'][day] !== " AM -  PM"){		
				allHours.push([conAmHours,parseInt(amHours[1]),true, separated[0]+" "+separated[1]])
				allHours.push([conPmHours,parseInt(pmHours[1]),false, separated[3]+" "+separated[4]])
			}
		}
		//this assumes they dont close and open during the same hour (who does that?)
		//if someone randomly does this, add another sort by minute
		allHours.sort(function(a,b){
			return(a[0]-b[0])
		})
		//find the first element that is past the current time
		let test = allHours.find((element)=>{
			if(element[0]>=convertedDate[0]){
				if(element[0]===convertedDate[0]){
					if(element[1]>convertedDate[1]){
						return true
					}
				}
				else if (element[0] > convertedDate[0]){
					return true
				}
			}
		})
		//if undefined, assume it is past the last open/close time on the last day with hours
		if(test===undefined){
			test = allHours[0]
		}
		let blurb = ""
		// fix things like "08:30" - drop the first zero
		if(test[3][0]==="0"){
			test[3] = test[3].slice(1)
		}

		if(currentDate.getDay()===Math.floor(test[0]/24)){
			blurb = (test[2]?" opens at ":" closes at ") + test[3]
		}
		else{
			blurb = (test[2]?" opens on ":" closes on ") + hoursFunctions.dayOfWeek(Math.floor(test[0]/24)) + " at " + test[3]
		}

		return {id: restaurant['restaurantId'], isOpen: !test[2], opensAt: blurb};
	},

	convert24Hour(hours, ampm){
		if (hours === 12 && ampm === "AM") {
			return(0);
		}
		else if (parseInt(hours) === 12 && ampm === "PM"){
			return(hours);
		}
		else if (ampm === 'AM'){
			return(hours);
		}
		else if (ampm === 'PM'){
			let calc = parseFloat(hours, 10)+12;
			return(calc);
		}
		else{
			return('error');
		}
	},

	dayOfWeek(number){
    switch(number){
      case 0:
        return('Sunday')
      case 1:
        return('Monday')
      case 2:
        return('Tuesday')
      case 3:
        return('Wednesday')
      case 4:
        return('Thursday')
      case 5:
        return('Friday')
      case 6:
        return('Saturday')
      default:
        return('Oops')
    }
  }
}
